import { cart as enCart } from '../en-us/cart';

export const cart = {
  ...enCart,
  title: 'Dein Warenkorb',
  giftCartTitle: 'Geschenke',
  checkoutButtonLabel: 'Zur Kasse',
  oneTimeCarouselTitle: 'Das könnte dir auch gefallen',
  frequencyLabel: 'Wird alle 30 Tage geliefert',
  clearCartText: 'Klare Produkte',
  subscriptionTitle: 'Abonnement',
  Free: 'Kostenlos',
  deliveryInfo:
    'Wenn du den Kauf abschließt, wird der angegeben Rechnungsbetrag fällig. Normalweise versenden wir montags bis freitags innerhalb von 24 Stunden nach erfolgter Zahlung. An Wochenenden und Feiertagen kann das bis zu 48 Stunden dauern.',
  oneTimeDescription: 'Diese Artikel werden mit der ersten Abo-Bestellung geliefert:',
  oneTimeCarouselAddButton: 'Hinzufügen',
  oneTimeTitle: 'Einmaliger Kauf',
  deleteItemModal: {
    title: 'Aus dem Warenkorb entfernen?',
    description:
      'Bist du sicher, dass du die ausgewählten Artikel aus dem Warenkorb entfernen willst?'
  },
  clearCartModal: {
    title: 'Alle Artikel aus dem Warenkorb entfernen',
    description: 'Sind Sie sicher, dass Sie alle Artikel aus dem Warenkorb entfernen möchten?'
  },
  emptyState: {
    oneTimeProductsTitle: 'Community Favoriten',
    addOneTimeProductButton: 'In den Warenkorb',
    label: 'Zum Warenkorb hinzufügen'
  }
};
